import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

const NawisPortfolio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Nawis App | Desarrollo de Aplicación Móvil y Branding | Mood Agency</title>
      <meta name="description" content="Caso de éxito Nawis: Desarrollo de aplicación móvil interactiva, estrategia de branding y lanzamiento de producto que conectó la creatividad física con el mundo digital." />
      <meta name="keywords" content="Nawis App, desarrollo de aplicaciones, branding, estrategia de lanzamiento, diseño UI/UX, gamificación, marketing digital" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal like Home */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO 2016
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            NAWIS APP
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Desarrollo de aplicación móvil y branding: Conectando la creatividad física con el mundo digital.
          </p>
        </div>
      </section>

      {/* Key Metrics - Minimalist Grid */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Go-to-Market</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Estrategia de Lanzamiento</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Phygital</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Fusión Físico-Digital</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Viral</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Crecimiento Orgánico</p>
          </div>
        </div>
      </section>

      {/* The Context - Clean Typography */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Nawis es la primera marca venezolana de Wood Toys diseñados para ser personalizados. Son lienzos en blanco tridimensionales listos para recibir color. Pequeños amigos intergalácticos que despiertan la creatividad de los terrícolas.
          </p>
        </div>
      </section>

      {/* Visual Break - Full Width Image */}
      <section className="w-full h-[80vh] overflow-hidden">
        <img 
          src="/assets/images/portfolio/nawis/header.png" 
          alt="Nawis App Branding" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-out"
        />
      </section>

      {/* The Challenge - Minimal List */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Miedo al Error
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              Los Nawis llegaron a la Tierra "en blanco". El desafío del producto físico era la ansiedad del usuario: solo tienes una oportunidad para pintar tu Wood Toy. Si te equivocas, no hay vuelta atrás.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Barrera Creativa</h3>
              <p className="font-sans text-gray-500">¿Cómo podíamos eliminar el miedo a equivocarse y potenciar la creatividad antes de tocar el juguete real?</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Conexión Digital</h3>
              <p className="font-sans text-gray-500">Necesitábamos crear un puente entre el juguete físico y el entorno digital donde viven los usuarios.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Comunidad</h3>
              <p className="font-sans text-gray-500">Fomentar que los usuarios compartieran sus creaciones e inspiraran a otros.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution - Grid Layout */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Nawis App</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñamos una aplicación móvil gamificada que permite a los usuarios colorear y personalizar sus Nawis digitalmente tantas veces como quieran antes de pintar el real.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Laboratorio Creativo</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Herramientas intuitivas (brocha, gotero, borrador) para probar colores y diseños sin riesgos, eliminando la ansiedad del lienzo en blanco.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Social Sharing</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Integración nativa con redes sociales para compartir los diseños digitales, creando un efecto viral y una galería de inspiración comunitaria.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact - Minimal Text */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Impacto Global</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "La aplicación no solo resolvió el problema del miedo al error, sino que creó una comunidad global. Los Nawis pasaron de ser un juguete local a un fenómeno digital compartido en redes sociales."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NawisPortfolio;
